import '@eats/common/lib/webpack-public-path/client'
window.frameworkInitStep = 'inited'
void import('./clientBootstrap')
